import React, { PureComponent } from 'react'


class TodoLoading extends PureComponent {
    render() {
        return (
            <div className="text-center">
                <div
                className="spinner-grow text-primary"
                style={{ width: "7rem", height: "7rem" }}
                role="status"
                >
                <span className="sr-only">Loading...</span>
                </div>
            </div>
        )
    }
}

export default TodoLoading
